import { Box } from "@mui/material";
import { onboardingTokens } from "../../theme";
import { t } from "../../../../locales/t";

/**
 * The goals a member chose, as a centred row of static pills. Navy text on
 * light teal: the design's teal text on light teal is too low in contrast.
 */
const GoalPills = ({ goals }) => (
  <Box
    component="ul"
    sx={{
      listStyle: "none",
      m: 0,
      p: 0,
      mb: 3,
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: 1,
    }}
  >
    {goals.map((goal) => (
      <Box
        component="li"
        key={goal}
        sx={{
          px: 1.5,
          py: 0.5,
          borderRadius: 999,
          fontSize: "0.8125rem",
          fontWeight: 600,
          color: onboardingTokens.navy,
          backgroundColor: onboardingTokens.lightTeal,
          border: `1px solid ${onboardingTokens.teal}`,
        }}
      >
        {t(`onboarding.done.goals.${goal}`)}
      </Box>
    ))}
  </Box>
);

export default GoalPills;
